import { useState, useEffect } from 'react'
import { Checkbox } from 'antd'
import { LoadingPage } from "../../../../shared/components/LoadingPage";
import { TableInfo } from "../../../../shared/components/Table";
import { useGetMovimentoContato } from "../../hooks/useGetMovimentoContato";
import { columnsMovimentos } from "../../utils/columnsMovimentos";

interface MovimentosContatoProps {
  ContatoId: number;
  Nome: string | undefined;
  Sobrenome: string | undefined;
  setHaveMovToPrint: (setMovToPrint : boolean) => void
}


export function MovimentosContato({ ContatoId, Nome, Sobrenome, setHaveMovToPrint }: MovimentosContatoProps) {
  const [movimentos, setMovimentos] = useState<any[]>([]);
  const [movToPrint, setMovToPrint] = useState<any[]>([]);
  
  const handleChangeChecked = (e: any, record: any) => {
    const checked = e.target.checked;
    console.log('passou: ', e.target.checked)
    if (checked) {
      console.log('entrei true: ', checked)
      setMovToPrint((prev: Array<any>) => [...prev, record]);
    } else {
      setMovToPrint((prev: Array<any>) => prev.filter((item: any) => item.MovimentoId !== record.MovimentoId));
    }
  }

  const columns = [{
    title: "Selecionar",
    width: 50,
    render: (text: any, record: any, index: any) => {
      return (
        <>
          {
            record && <div className=" flex justify-center">
              <Checkbox 
                key={index}
                name={text}
                onChange={(e: any) => handleChangeChecked(e, text)}
              />
            </div>
          }
        </>
      );
    },
  },
    ...columnsMovimentos
  ]

  const { data: Movimento, isLoading } = useGetMovimentoContato(ContatoId);
  const MovimentoContatoData = movimentos?.map((movimento: any, index: number) => ({
    key: index,
    NovoProdutoNome: `${movimento.ProdutoNome}(${movimento.ProdutoCodigoFornecedor})`,
    ...movimento,
  }));

  useEffect(() => {
    setMovimentos(Movimento)
  }, [Movimento])

  useEffect(() => {
    localStorage.setItem('movimento', JSON.stringify(movToPrint));
    localStorage.setItem('contato', JSON.stringify(`${Nome} ${Sobrenome}`));
  },[movToPrint, Nome, Sobrenome])

  return (
    <div className="w-[70rem] h-[30rem] overflow-hidden overflow-y-auto">
      <>{movToPrint.length > 0 ? setHaveMovToPrint(true) : setHaveMovToPrint(false)}</>
      {isLoading ? <div className="h-[30rem] flex items-center justify-center"><LoadingPage /></div> : 
        <TableInfo
        dataSource={MovimentoContatoData}
        columns={columns}
        />
      }
    </div>
  );
}
